<template>
	<footer id="site-footer">
		<div class="row">
			<div class="columns small-12 large-7">
				<nav class="text-links">
					<a v-bind:href="data.ruter_url" v-text="data.ruter_no"></a>
					<router-link v-bind:to="{path: cookiesPath}" v-text="data.cookies"></router-link>
				</nav>
				<nav class="social-links">
					<a v-for="(link, index) in data.social_links" v-bind:key="'social-link-' + index" v-bind:href="link.url" v-text="link.name" v-bind:class="['social-link', index]"></a>
				</nav>
			</div>
			<div class="columns small-12 large-5" v-html="sanitizedDCLink"></div>
		</div>
	</footer>
</template>

<script>
import DOMPurify from 'dompurify';
export default {
	props: ['data'],
	computed: {
		cookiesPath() {
			return '/' + this.$store.state.lang + '/' + this.data.cookies_page
		},
		sanitizedDCLink() {
			return DOMPurify.sanitize(this.data.dc_link)
		}
	}
}
</script>

<style lang="scss">
  @import "../../styles/scss/global/footer";
</style>